
import { Component, Vue } from 'vue-property-decorator';
import { messageLists, readAll } from '@/apis/myInfo/myInfo';
import moment from 'moment';
import { typeRedirect } from '@/utils/common';
import { CourseHomeIconMap } from '@/utils/dictionary';
import i18n from '@/lang';
import { Toast } from 'vant';
@Component({})
export default class MessageNotice extends Vue {
  private active: number = 0;
  private tabsList: Array<string> = [
    i18n.t('Common.全部') as string,
    i18n.t('ktpMy.教学活动') as string,
    i18n.t('ktpMy.教务通知') as string,
    i18n.t('ktpMy.系统通知') as string,
    i18n.t('ktpMy.申诉') as string
  ];
  private courseContentType = [
    '',
    i18n.t('Common.CourseMenu.互动课件'),
    i18n.t('Common.CourseMenu.资料') ,
    i18n.t('ktpMy.互动试卷'),
    i18n.t('Common.CourseMenu.作业') ,
    i18n.t('Common.CourseMenu.话题'),
    i18n.t('Common.CourseMenu.测试'),
    i18n.t('Common.CourseMenu.公告') ,
    i18n.t('Common.外链'), '', '', '', '', '', '',
    i18n.t('CourseHome.考勤'),
    i18n.t('CourseHome.表现')
  ];
  moment = moment;
  private showInfoData: Array<any> = [];
  private loading: boolean = false;
  private finished: boolean = false;
  private pagesSize: number = 10; //页面显示数量
  private currentPage: number = 1; //当前页码
  private type: number = 100;
  private Allpage: number = 0; //页数
  private iconMap = CourseHomeIconMap;

  changeTab(val: any) {
    this.showInfoData = [];
    this.currentPage = 1;

    switch (val) {
      case 0:
        this.type = 100;
        break;
      case 1:
        this.type = 0;
        break;
      case 2:
        this.type = 1;//机构通知
        break;
      case 3:
        this.type = 2;
        break;
      case 4:
        this.type = 3;
        break;
    }
    this.getData(this.pagesSize);
    if (this.Allpage == 1) {
      this.finished = true;
      return;
    }
  }
  //单个忽略
  ignore(index: number) {
    readAll({ type: 0, messageID: this.showInfoData[index].id })
      .then((res:any) => {
        this.showInfoData[index].isread = '1';
        Toast.success(i18n.t('Home.Handle.已忽略'));
      })
    .catch((e:any) => {});
  }
  onLoad() {
    setTimeout(() => {
      if (this.currentPage <= this.Allpage) {
        this.currentPage++;
        this.getData(this.currentPage);
        this.loading = false;
      } else {
        this.finished = true;
        this.loading = true;
      }
    }, 1000);
  }
  created() {
    this.$setNavInfo({
      title: i18n.t('ktpMy.消息通知') as string,
      btnGroup: [
        {
          text: i18n.t('ktpMy.忽略全部') as string,
          type: 'text',
          callback: this.ignoreAll,
          color: '#4285F4'
        }
      ]
    });
    this.getData(this.currentPage);
  }
  // 点击忽略全部
  ignoreAll() {
    readAll({ type: 0 })
      .then((res:any) => {
        for (let i = 0; i < this.showInfoData.length; i++) {
          this.showInfoData[i].isread = '1';
        }
        Toast.success(i18n.t('Home.Handle.已忽略'));
      })
      .catch((e:any) => {});
  }
  //下拉加载
  jump(item: any) {
    if(item.courseid != "0"  && item.courseid != ""){
      if(item.eventtype == 99){
        this.$dialog.alert({
          title: i18n.t('ktpMy.消息标题') as string,
          message: "请在PC端进行处理申诉，移动端暂不支持该类消息",
          theme: 'warning',
        });
        return;
      }
      const { courseid, role } = item;
      window.sessionStorage.setItem('courseId', courseid);
      typeRedirect.call(this, item.contenttype, {
        courseId: item.courseid,
        courseRole: String(item.courserole),
        // @ts-ignore
        dataInfo: {
          id: item.contentid
        }
      });
    }else{
      if(item.type == 1){
        this.$router.push({path:'/schoolmsg',query:{id:item.id,type:item.type,coid:item.coid}});
      }else{
        this.$dialog.alert({
          title: i18n.t('ktpMy.消息标题') as string,
          message: item.title,
        });
      }
    }
  }

  getData(currentPage: number) {
    messageLists({ currentPage: this.currentPage, pageSize: this.pagesSize, type: this.type })
      .then((res: any) => {
        this.Allpage = res.pageTotal;
        this.showInfoData = this.showInfoData.concat(res.list);
        let leng = this.showInfoData.length;
      })
      .catch(e => {});
  }

}
